export default "__VITE_ASSET__NsKaam$P__"